import React, { useState, useEffect, useMemo } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function Manageuser() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [downloadedItems, setDownloadedItems] = useState([]);
  const [concepts, setConcepts] = useState([]);
  // --- UPDATED SEARCH STATE ---
  const [mainFilters, setMainFilters] = useState({
    userId: "",
    phone: "",
  });

  // Modal States
  const [showUserModal, setShowUserModal] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);

  // Filters for Orders within the User Modal
  const [orderFilters, setOrderFilters] = useState({
    fromDate: "",
    toDate: "",
    orderId: "",
  });

  // --- UPDATED FILTER LOGIC FOR MAIN TABLE ---
  const filteredUsers = useMemo(() => {
    return users.filter((u) => {
      const matchesId = mainFilters.userId
        ? u.id.toString().includes(mainFilters.userId)
        : true;
      const matchesPhone = mainFilters.phone
        ? u.phone.toString().includes(mainFilters.phone)
        : true;

      return matchesId && matchesPhone;
    });
  }, [users, mainFilters]);

  const getFilteredOrders = () => {
    if (!userDetails) return [];
    return userDetails.orders.filter((order) => {
      const orderDate = new Date(order.created_at).toISOString().split("T")[0];
      const matchesFrom = orderFilters.fromDate
        ? orderDate >= orderFilters.fromDate
        : true;
      const matchesTo = orderFilters.toDate
        ? orderDate <= orderFilters.toDate
        : true;
      const matchesId = orderFilters.orderId
        ? order.id.toString().includes(orderFilters.orderId)
        : true;

      return matchesFrom && matchesTo && matchesId;
    });
  };

  useEffect(() => {
    fetchUsers();
    fetchConcepts(); // ✅ ADD THIS
  }, []);

  // ✅ NEW: Fetch concepts function
  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) {
        setConcepts(data.data);
      }
    } catch (error) {
      console.log("Concepts fetch error:", error);
    }
  };

  // ✅ NEW: Helper to get concept names from IDs
  const getConceptNames = (conceptIds) => {
    if (!conceptIds || !Array.isArray(conceptIds)) return "N/A";

    return (
      conceptIds
        .map((id) => {
          const concept = concepts.find((c) => c.id == id);
          return concept ? concept.concept_name : null;
        })
        .filter(Boolean)
        .join(", ") || "N/A"
    );
  };

  const fetchUsers = async () => {
    try {
      const res = await fetch(API.LIST_USERS);
      const data = await res.json();
      if (data.success) setUsers(data.users);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewUser = async (user) => {
    try {
      const res = await fetch(`${API.USER_DETAILS}&id=${user.id}`);
      const data = await res.json();
      if (data.success) {
        setUserDetails(data);
        setShowUserModal(true);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleCloseAll = () => {
    setShowUserModal(false);
    setUserDetails(null);
    setSelectedOrder(null);
  };

  const handleBlockStatus = async (action) => {
    const newStatus = action === "block" ? "blocked" : "active";

    if (!window.confirm(`Are you sure you want to ${action} this user?`))
      return;

    try {
      const url = action === "block" ? API.BLOCK_USER : API.UNBLOCK_USER;
      const res = await fetch(`${url}&id=${userDetails.user.id}`);
      const data = await res.json();

      if (data.success) {
        // 1. Update the Main Table Background
        setUsers((prevUsers) =>
          prevUsers.map((u) =>
            u.id === userDetails.user.id ? { ...u, status: newStatus } : u,
          ),
        );

        // 2. Update the currently open Modal Details
        setUserDetails((prev) => ({
          ...prev,
          user: { ...prev.user, status: newStatus },
        }));

        alert(`User has been ${newStatus} successfully.`);
      }
    } catch (err) {
      console.error("Status update failed", err);
      alert("Action failed. Please check your connection.");
    }
  };
  const handleViewOrderDetails = async (orderId) => {
    try {
      const res = await fetch(API.ALL_ORDERS);
      const data = await res.json();
      if (data.success) {
        const fullOrder = data.orders.find((o) => o.id === orderId);
        setSelectedOrder(fullOrder);
      }
    } catch (err) {
      console.error("Error fetching detailed order info", err);
      alert("Could not load order items.");
    }
  };
  const handleDownloadEmb = (item) => {
    try {
      const fileUrl = `${UPLOADS.DESIGN_EMB}${item.emb_file}`;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = `${item.design_code}.emb`;
      document.body.appendChild(link);
      link.click();
      link.remove();

      // ✅ Mark as downloaded
      setDownloadedItems((prev) => [...prev, item.design_code]);
    } catch (error) {
      console.error("Download failed:", error);
      alert("Download failed");
    }
  };
  if (loading) return <div className="text-center mt-5">Loading Users...</div>;

  return (
    <div className="container-fluid px-4 py-5 bg-light min-vh-100">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="machine-title">Customer Management</h2>
        <span className="badge bg-teal p-2 px-3">
          {users.length} Total Users
        </span>
      </div>

      {/* --- NEW SEARCH BAR UI FOR MAIN TABLE --- */}
      <div className="row g-3 mb-4 no-print">
        <div className="col-md-3">
          <div className="input-group shadow-sm">
            <span className="input-group-text bg-white border-end-0">
              <i className="bi bi-hash text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control border-start-0"
              placeholder="Search by ID..."
              value={mainFilters.userId}
              onChange={(e) =>
                setMainFilters({ ...mainFilters, userId: e.target.value })
              }
            />
          </div>
        </div>
        <div className="col-md-4">
          <div className="input-group shadow-sm">
            <span className="input-group-text bg-white border-end-0">
              <i className="bi bi-telephone text-muted"></i>
            </span>
            <input
              type="text"
              className="form-control border-start-0"
              placeholder="Search by Phone Number..."
              value={mainFilters.phone}
              onChange={(e) =>
                setMainFilters({ ...mainFilters, phone: e.target.value })
              }
            />
          </div>
        </div>
        {(mainFilters.userId || mainFilters.phone) && (
          <div className="col-md-2 d-flex align-items-center">
            <button
              className="btn btn-sm btn-link text-danger text-decoration-none"
              onClick={() => setMainFilters({ userId: "", phone: "" })}
            >
              Clear Filters
            </button>
          </div>
        )}
      </div>

      {/* MAIN USERS TABLE */}
      <div className="table-responsive bg-white rounded shadow-sm">
        <table className="table table-hover align-middle mb-0">
          <thead>
            <tr className="bg-light text-muted small">
              <th className="ps-4">ID</th>
              <th>NAME / PHONE</th>
              <th>CREATED DATE</th>

              <th>CITY</th>
              <th>ACCOUNT_TYPE</th>
              <th>STATUS</th>
              <th className="text-end pe-4">ACTION</th>
            </tr>
          </thead>
          <tbody>
            {filteredUsers.length > 0 ? (
              filteredUsers.map((u) => (
                <tr key={u.id}>
                  <td className="ps-4 fw-bold text-teal">{u.id}</td>
                  <td>
                    <div className="fw-bold">{u.name}</div>
                    <div className="text-muted small">{u.phone}</div>
                  </td>
                  <td>
                    <div className="fw-bold">
                      {new Date(u.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(u.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>

                  <td>
                    <div className="fw-bold">{u.city}</div>
                    <div className="text-muted small">{u.state}</div>
                  </td>
                  <td>
                    <div className="fw-bold">{u.account_type}</div>
                    <div className="text-muted small">{u.provider_options}</div>
                  </td>
                  <td>
                    <span className={`status-pill ${u.status?.toLowerCase()}`}>
                      {u.status}
                    </span>
                  </td>
                  <td className="text-end pe-4">
                    <button
                      className="btn btn-sm btn-outline-teal"
                      onClick={() => handleViewUser(u)}
                    >
                      View Profile
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-5 text-muted">
                  No users found matching your search.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* ... (Modals and Styles remain same as your provided code) ... */}

      {/* MODAL 1: USER PROFILE & ORDER LIST */}
      {showUserModal && userDetails && (
        <div className="custom-modal-overlay" onClick={handleCloseAll}>
          <div
            className="custom-modal-card"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header-custom">
              <h5 className="mb-0 fw-bold">User Profile & History</h5>
            </div>

            <div className="modal-body-custom">
              <div className="row mb-4 border-bottom pb-3">
                <div className="col-md-6">
                  {/* <label>Personal Information</label> */}
                  <p className="fw-bold mb-0" style={{ fontSize: "1.2rem" }}>
                    {userDetails.user.name}
                  </p>
                  <p className="text-muted small">
                    {userDetails.user.phone} | {userDetails.user.email}{" "}
                  </p>
                </div>
                <div className="col-md-6 text-md-end">
                  <label className="text-muted small d-block">
                    Account Status
                  </label>
                  <span
                    className={`status-pill ${userDetails.user.status?.toLowerCase()}`}
                  >
                    {userDetails.user.status}
                  </span>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <label className="mb-0">Recent Orders</label>
                <div className="d-flex align-items-center gap-2">
                  <label className="small fw-bold text-muted mb-0">From:</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={orderFilters.fromDate}
                    onChange={(e) =>
                      setOrderFilters({
                        ...orderFilters,
                        fromDate: e.target.value,
                      })
                    }
                  />
                </div>
                <div className="d-flex align-items-center gap-2">
                  <label className="small fw-bold text-muted mb-0">To:</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={orderFilters.toDate}
                    onChange={(e) =>
                      setOrderFilters({
                        ...orderFilters,
                        toDate: e.target.value,
                      })
                    }
                  />
                </div>
                {(orderFilters.fromDate || orderFilters.toDate) && (
                  <button
                    className="btn btn-sm btn-link text-danger p-0"
                    onClick={() =>
                      setOrderFilters({ fromDate: "", toDate: "" })
                    }
                  >
                    Clear
                  </button>
                )}
                <input
                  type="text"
                  className="form-control form-control-sm"
                  placeholder="Order ID"
                  style={{ width: "100px" }}
                  onChange={(e) =>
                    setOrderFilters({
                      ...orderFilters,
                      orderId: e.target.value,
                    })
                  }
                />
              </div>
              {/* <div className="d-flex gap-2">
                <label className="small fw-bold text-muted mb-0">From:</label>
                  <input 
                    type="date" 
                    className="form-control form-control-sm" 
                    onChange={(e) => setOrderFilters({...orderFilters, fromDate: e.target.value})}
                  />
             
                  <input 
                    type="date" 
                    className="form-control form-control-sm" 
                    onChange={(e) => setOrderFilters({...orderFilters, toDate: e.target.value})}
                  />
                  <input 
                    type="text" 
                    className="form-control form-control-sm" 
                    placeholder="Order ID" 
                    style={{width: '100px'}}
                    onChange={(e) => setOrderFilters({...orderFilters, orderId: e.target.value})}
                  />
                </div>
              </div> */}

              <div className="table-responsive border rounded">
                <table className="table table-sm align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="small text-muted">
                      <th className="ps-3">Order ID</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Amount</th>
                      <th className="text-end pe-3">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getFilteredOrders().length > 0 ? (
                      getFilteredOrders().map((order) => (
                        <tr key={order.id}>
                          <td className="ps-3 fw-bold">#{order.id}</td>
                          <td>
                            {new Date(order.created_at).toLocaleDateString()}
                          </td>
                          <td className="text-muted small">
                            {new Date(order.created_at).toLocaleTimeString([], {
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </td>
                          <td className="fw-bold text-teal">
                            ₹{order.total_amount}
                          </td>
                          <td className="text-end pe-3">
                            <button
                              className="btn btn-sm btn-teal"
                              onClick={() => handleViewOrderDetails(order.id)}
                            >
                              View Details
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-3">
                          No orders match these filters
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="modal-footer-custom">
              {/* Check status to toggle between Unblock and Block buttons */}
              {userDetails.user.status?.toLowerCase() === "blocked" ? (
                <button
                  onClick={() => handleBlockStatus("unblock")}
                  className="btn btn-success btn-block-action me-2"
                >
                  <i className="bi bi-unlock-fill me-1"></i> Unblock User
                </button>
              ) : (
                <button
                  onClick={() => handleBlockStatus("block")}
                  className="btn btn-danger btn-block-action me-2"
                >
                  <i className="bi bi-slash-circle me-1"></i> Block User
                </button>
              )}
              <button className="btn btn-light border" onClick={handleCloseAll}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* MODAL 2: DETAILED ORDER INFO */}
      {selectedOrder && (
        <div
          className="custom-modal-overlay second-modal"
          onClick={() => setSelectedOrder(null)}
        >
          <div
            className="custom-modal-card animate-slide-up"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: "850px" }}
          >
            <div className="modal-header-custom bg-dark text-white">
              <h5 className="mb-0 fw-bold">
                Order Details #{selectedOrder.order_no || selectedOrder.id}
              </h5>
              <button
                className="close-btn text-white"
                onClick={() => setSelectedOrder(null)}
              >
                &times;
              </button>
            </div>

            <div className="modal-body-custom">
              <div className="row mb-4 border-bottom pb-3">
                <div className="col-md-6">
                  <label>Order Information</label>
                  <p className="fw-bold mb-0">
                    Status:{" "}
                    <span
                      className={`status-pill ${selectedOrder.status.toLowerCase()}`}
                    >
                      {selectedOrder.status}
                    </span>
                  </p>
                </div>
                <div className="col-md-6 text-md-end">
                  <label>Total Amount</label>
                  <h4 className="fw-bold text-teal">
                    ₹{selectedOrder.total_amount}
                  </h4>
                </div>
              </div>

              <label className="mb-3">Items in this Order</label>
              <div className="table-responsive border rounded">
                <table className="table table-sm align-middle mb-0">
                  <thead className="bg-light">
                    <tr className="small text-muted">
                      <th className="ps-3 py-2">Preview</th>
                      <th>Design code</th>
                      <th>Specifications</th>
                      <th>Concept</th> {/* ✅ NEW COLUMN */}
                      <th>Details</th>
                      <th>Download</th>
                      <th className="text-end pe-3">Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedOrder.items && selectedOrder.items.length > 0 ? (
                      selectedOrder.items.map((item, index) => {
                        // ✅ FIX: Parse concepts INSIDE the map function
                        let conceptIds = [];
                        try {
                          if (
                            item.concepts_array &&
                            Array.isArray(item.concepts_array)
                          ) {
                            conceptIds = item.concepts_array;
                          } else if (item.concepts) {
                            conceptIds = JSON.parse(item.concepts || "[]");
                          }
                        } catch (e) {
                          console.log("Concept parse error:", e);
                        }

                        // ✅ FIX: Calculate conceptNames INSIDE the map function
                        const conceptNames = getConceptNames(conceptIds);

                        return (
                          <tr key={index}>
                            <td className="ps-3 py-2">
                              <img
                                src={`${UPLOADS.DESIGN_IMAGE}${item.jpeg_file}`}
                                alt="Design"
                                className="rounded border bg-white"
                                style={{
                                  width: "60px",
                                  height: "60px",
                                  objectFit: "contain",
                                }}
                                onError={(e) => {
                                  e.target.src =
                                    "https://via.placeholder.com/60";
                                }}
                              />
                            </td>
                            <td>
                              <div className="fw-bold small">
                                {item.design_code}
                              </div>
                            </td>
                            <td>
                              <div className="small">
                                <b>Area:</b> {item.area || "N/A"}
                              </div>
                              <div className="small">
                                <b>Stitches:</b>{" "}
                                {item.stitch || item.stitches || "N/A"}
                              </div>
                            </td>

                            {/* ✅ FIXED: Now conceptNames is defined in scope */}
                            <td className="small" title={conceptNames}>
                              {conceptNames.length > 15
                                ? `${conceptNames.substring(0, 15)}...`
                                : conceptNames}
                            </td>

                            {/* ✅ DETAILS */}
                            <td className="small">{item.details || "N/A"}</td>

                            <td>
                              {item.emb_file ? (
                                downloadedItems.includes(item.design_code) ? (
                                  <span className="text-success small fw-bold">
                                    <i className="bi bi-check-circle"></i>{" "}
                                    Downloaded
                                  </span>
                                ) : (
                                  <button
                                    onClick={() => handleDownloadEmb(item)}
                                    className="btn btn-sm btn-outline-primary"
                                  >
                                    <i className="bi bi-download"></i> EMB
                                  </button>
                                )
                              ) : (
                                <span className="text-muted small">
                                  No File
                                </span>
                              )}
                            </td>

                            <td className="text-end pe-3 fw-bold small">
                              ₹
                              {item.price
                                ? item.price * (item.qty || 1)
                                : "---"}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="7" className="text-center py-3">
                          No items found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="modal-footer-custom">
              <button
                className="btn btn-dark"
                onClick={() => setSelectedOrder(null)}
              >
                Back to Profile
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .bg-teal, .btn-teal { background-color: #00a99d !important; color: white !important; }
        .text-teal { color: #00a99d !important; }
        .btn-outline-teal { border: 1px solid #00a99d; color: #00a99d; }

  /* Status Pill Base */
  .status-pill {
    padding: 6px 14px;
    border-radius: 50px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    display: inline-block;
    transition: all 0.3s ease;
  }

  /* Active/Normal Status - Green */
  .active, .completed {
    background: #e6f4ea !important;
    color: #1e7e34 !important;
    border: 1px solid #c3e6cb;
  }

  /* Blocked/Cancelled Status - Red */
  .blocked, .cancelled {
    background: #fce8e8 !important;
    color: #d93025 !important;
    border: 1px solid #f5c6cb;
  }

  /* Pending Status - Orange/Yellow */
  .pending {
    background: #fff4e5 !important;
    color: #664d03 !important;
    border: 1px solid #ffeeba;
  }

  /* Specific Button styling for Block action */
  .btn-block-action {
    min-width: 120px;
  }

     
        .second-modal { z-index: 1100; background: rgba(0, 0, 0, 0.7); }
        .custom-modal-card { background: white; width: 95%; max-width: 900px; border-radius: 12px; overflow-y: auto; max-height: 90vh; }
        .modal-header-custom { padding: 15px 25px; border-bottom: 1px solid #eee; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; z-index: 10; }
        .modal-body-custom { padding: 25px; }
        .modal-footer-custom { padding: 15px 25px; border-top: 1px solid #eee; text-align: right; background: #f8f9fa; }
        .close-btn { background: red; border: none; font-size: 24px; color: #999; }
        .animate-slide-up { animation: slideUp 0.3s ease-out; }
        @keyframes slideUp { from { transform: translateY(20px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      `}</style>
    </div>
  );
}
